import React from 'react';
import { modals } from '@mantine/modals';
import type { TEnrollProtocol } from '@besuites/auth/flow';
import StepUpPanel from '@/components/auth/step-up/Step.Up.Panel';

type Options = { title?: string; enroll?: TEnrollProtocol | null };

let sequence = 0;

export default function openStepUp({ title = 'Conferma che sei tu', enroll = null }: Options = {}): Promise<boolean> {
    sequence += 1;
    const modalId = `step-up-${sequence}`;
    return new Promise((resolve) => {
        let settled = false;
        const settle = (value: boolean) => {
            if (settled) return;
            settled = true;
            modals.close(modalId);
            resolve(value);
        };
        modals.open({
            modalId,
            title,
            centered: true,
            size: 440,
            onClose: () => settle(false),
            children: <StepUpPanel enroll={enroll} onDone={() => settle(true)} onCancel={() => settle(false)} />,
        });
    });
}
